import React from "react";
import Button from "../components/Button/Button";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const AnalyzeAndGrow = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className="w-full bg-[#f9fafb] py-20" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 text-center flex flex-col items-center">
        {/* Top Text */}
        <motion.h2
          initial={{ y: -50, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-3xl md:text-6xl font-semibold text-gray-900 mb-6"
        >
          Analyze & Grow
        </motion.h2>

        <motion.p
          initial={{ y: -30, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
          className="text-gray-600 text-lg max-w-5xl mb-12"
        >
          With actionable reports, easily identify areas to improve and refine your service.
          The insights you need to make better decisions are always at your fingertips.
        </motion.p>

        {/* Image and Analytics */}
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={inView ? { scale: 1, opacity: 1 } : {}}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
          className="relative w-full flex justify-center"
        >
          <img
            src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50ca2d058c933cd5af7e8_Group%201000005170.png"
            alt="Analyze and Grow"
            className="w-full max-w-3xl object-contain z-10"
          />
        </motion.div>

        {/* Buttons */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="flex flex-col md:flex-row gap-4 mt-12"
        >
          <Button variant="primary">Get Started</Button>
          <Button variant="secondary" calendly>Book a demo</Button>
        </motion.div>
      </div>
    </section>
  );
};

export default AnalyzeAndGrow;
